import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

import {StudentListModel} from './StudentListModel.js';
import {StudentListTable} from './StudentListTable.js';
import {StudentSelectModel} from './StudentSelectModel.js';
import {MessageForm} from './MessageForm.js';

export class StudentListController {
	constructor(parent) {
		[this.el, this.$] = DojoTemplates('StudentListController');
		Eventify(this.el, {
			'addStudent': evt => {
				evt.preventDefault();
				document.location = '/students/edit/0';
			},
			'messageClick': evt=> {
				evt.preventDefault();
				this.messageForm.open();
			}
		}, this);
		let model = new StudentListModel();
		let selectModel = new StudentSelectModel(model);
		new StudentListTable(this.$.studentTable, model, selectModel);
		model.load();
		parent.appendChild(this.el);
		this.messageForm = new MessageForm(parent, selectModel);
	}
}

window.StudentListController = StudentListController;